import { apiFetch } from "./api";

let cachedImages = null;
let galleryRequest = null;
const imagePreloaders = [];

const preloadImage = (imageUrl) => {
  const image = new Image();
  image.src = imageUrl;
  imagePreloaders.push(image);
};

// Reuse the same signed URLs so opening /dojo does not trigger another image download.
export const preloadDojoGalleryImages = () => {
  if (cachedImages) return Promise.resolve(cachedImages);
  if (galleryRequest) return galleryRequest;

  galleryRequest = apiFetch("/api/dojo-gallery")
    .then((images) => {
      cachedImages = Array.isArray(images) ? images : [];
      cachedImages.forEach(({ imageUrl }) => preloadImage(imageUrl));
      return cachedImages;
    })
    .catch((error) => {
      galleryRequest = null;
      throw error;
    });

  return galleryRequest;
};

export const refreshDojoGalleryImages = () => {
  cachedImages = null;
  galleryRequest = null;
  return preloadDojoGalleryImages();
};